import { ConfigurableDatagridColumn, useRecordContext, useStore } from 'react-admin';
import { OrderList } from 'types/embedded/order';
import { formatInputInTz } from 'utils/date';
import { getId } from 'utils/getId';

export const useGetOrderCopyData = (timezone: string) => {
  const record = useRecordContext<OrderList>();
  const [availableColumns] = useStore<ConfigurableDatagridColumn[]>(
    'preferences.orders/list.datagrid.availableColumns',
    [],
  );

  const valueHandlers: Record<string, string | null | undefined> = {
    '@id': getId(record?.['@id']),
    createdAt: formatInputInTz(record?.createdAt, { timezone, format: 'dd/MM/yyyy HH:mm' }),
    updatedAt: formatInputInTz(record?.updatedAt, { timezone, format: 'dd/MM/yyyy HH:mm' }),
    currency: `${record?.currency}`,
    direction: record?.direction,
    method: record?.method,
    status: record?.status,
    gateway: record?.gateway,
    provider: record?.provider,
    merchant: record?.merchant,
    customer: record?.customerId,
  };
  const copyData = record
    ? availableColumns
        .filter(({ source }) => !!source)
        .map(({ source, label }) => {
          return valueHandlers[source as keyof typeof valueHandlers]
            ? `${label}: ${valueHandlers[source as keyof typeof valueHandlers]}`
            : `${label}: ${record[source as keyof OrderList]}`;
        })
        .join('\n')
    : '';

  return { copyData };
};
